import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles((theme) => ({
  searchRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  emailInput: {
    flex: 1,
  },
  results: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    paddingTop: theme.spacing(2),
  },
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    maxHeight: 300,
    overflow: "auto",
  },
  item: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  emptyText: {
    padding: "16px 0",
    textAlign: "center",
  },
}));
